import { useContext } from "react";
import ReuseModal from "../../../../../components/fragment/modal/ReuseModal";
import { useDispatch, useSelector } from "react-redux";
import { logoutUser } from "../../../../../redux/userAuth";
import { useNavigate } from "react-router-dom";
import { ALL_ROUTES } from "../../../../../routes/AllRoutes";
import RootState from "../../../../../redux/type";
import ActionContext from "../../../../../context/ActionContext";
// import ReuseModal from "../../../components/fragment/modal/ReuseModal";

export interface myComponentProps {
  onClose?: () => void;
  visible?: boolean;
  details?: any;
}

const EndSessionModal = ({ onClose, visible, details }: myComponentProps) => {
  const actionCtx = useContext(ActionContext);
  const { loading_logout } = useSelector((state: RootState) => state.auth);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const handleSubmit = async () => {
    const data = await dispatch(logoutUser(details) as any);

    if (data?.payload?.data?.status) {
      localStorage.clear();
      //   navigate(ALL_ROUTES?.LOGIN);
      setTimeout(() => {
        window.location.replace(ALL_ROUTES?.LOGIN);
      }, 1000);
      //   onClose && onClose();
      actionCtx?.setLogout && actionCtx?.setLogout(false);
    }
  };

  const handleClose = () => {
    actionCtx?.setLogout && actionCtx?.setLogout(false);
    // onClose && onClose();
  };

  return (
    <>
      <ReuseModal
        visible={visible}
        onClose={handleClose}
        deleteType
        loading={loading_logout}
        onBtnClick={handleSubmit}
        // btnColor="black-light"
        btnLabel="Logout session"
        title="End Sessions"
        deleteText='Are you sure you want to logout?, if yes click on "Logout session" or cancel the modal to prevent this action'
      />
    </>
  );
};

export default EndSessionModal;
